export default function maxOf(coll, pred) {
  return _.iteratee(pred)(_.maxBy(coll, pred));
}
